<template>
  <div class="container">
    <section class="project-detail">
      <div class="project-detail__header">
        <video v-if="project.video" ref="videoPlayer" controls autoplay>
          <source :src="project.video" type="video/mp4" />
        </video>
        <div
          v-if="project.illustrations && project.illustrations.length"
          class="project-detail__illustration"
        >
          <carousel
            v-if="project.illustrations.length > 1"
            :wrapAround="true"
            :transition="500"
            :navigation="true"
          >
            <Slide v-for="(image, index) in project.illustrations" :key="index">
              <img
                :src="image"
                :alt="project.title"
                @click="openFullScreen(index)"
              />
            </Slide>
            <template #addons>
              <Navigation />
            </template>
          </carousel>
          <img
            v-else
            :src="project.illustrations[0]"
            :alt="project.title"
            @click="openFullScreen(0)"
          />
        </div>
        <h1>{{ project.title.toUpperCase() }}</h1>
      </div>
      <div class="content">
        <p>{{ project.description }}</p>
        <a
          class="hoverable"
          v-if="project.link"
          :href="project.link"
          target="_blank"
          >{{ project.link }}</a
        >
        <h2>INFO SUR LE PROJET</h2>
        <BasicTable :tableItems="tableItems"></BasicTable>
      </div>
    </section>
    <ul class="project-navigation">
      <li class="nav-links__li">
        <router-link
          v-if="previousProject"
          :to="'/projets/' + previousProject.id"
        >
          ← {{ previousProject.title }}
          <span></span>
        </router-link>
      </li>
      <li class="nav-links__li">
        <router-link
          v-if="nextProject"
          :to="'/projets/' + nextProject.id"
        >
        {{ nextProject.title }} →
          <span></span>
        </router-link>
      </li>
    </ul>
    <Footer />
    <div v-if="isFullScreen" class="fullscreen-carousel">
      <button class="close-btn" @click="closeFullScreen">✖</button>
      <carousel
        :wrapAround="true"
        :transition="500"
        :navigation="true"
        :pagination="true"
        v-model="currentSlide"
      >
        <Slide v-for="(image, index) in project.illustrations" :key="index">
          <img :src="image" :alt="project.title" />
        </Slide>
        <template #addons>
          <Navigation />
        </template>
      </carousel>
    </div>
    <CursorLink :cursorMessage="cursorMessage" size="1"></CursorLink>
  </div>
</template>

<script>
import CursorLink from '../components/UIElements/cursorLink.vue';
import Footer from '@/components/Footer.vue';
import BasicTable from '../components/BasicTable.vue';
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';

export default {
  name: 'ProjectDetails',
  components: {
    BasicTable,
    CursorLink,
    Footer,
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      isFullScreen: false,
      currentSlide: 0,
      cursorMessage: 'Click',
    };
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        // this.loadProject(newId);
        this.$nextTick(() => {
          this.reloadVideo();
        });
      },
    },
  },
  methods: {
    reloadVideo() {
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.load();
        }
      });
    },
    openFullScreen(index) {
      this.currentSlide = index;
      this.isFullScreen = true;
    },
    closeFullScreen() {
      this.isFullScreen = false;
    },
  },
  computed: {
    projectId() {
      return Number(this.$route.params.id);
    },

    project() {
      return this.$store.state.projects.find(
        project => project.id === this.projectId
      );
    },
    tableItems() {
      return [
        {
          key: 'role',
          title: 'Role',
          content: this.project.role,
        },
        {
          key: 'year',
          title: 'Année',
          content: this.project.date,
        },
        {
          key: 'stack',
          title: 'Stack',
          content: this.project.stack.join(', '),
        },
      ];
    },
    previousProject() {
      const projects = this.$store.state.projects;
      const index = projects.findIndex(p => p.id === this.projectId);
      return index > 0 ? projects[index - 1] : null;
    },
    nextProject() {
      const projects = this.$store.state.projects;
      const index = projects.findIndex(p => p.id === this.projectId);
      return index !== -1 && index < projects.length - 1
        ? projects[index + 1]
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../components/NavLinks.scss';
.project-detail {
  position: relative;
  @media (min-width: 1024px) {
    .content {
      margin: 0 25%;
      margin-bottom: 3rem;
    }
  }
  @media (min-width: 1440px) {
    display: flex;
    flex-direction: row-reverse;
    // height: 100vh;
    margin-top: 5rem;
    align-items: center;
    &__header {
      width: 100%;
    }
    .content {
      margin: 0 2rem 0 0;
      width: 70%;
    }
  }
}
video,
img {
  margin-top: 1rem;
  width: 100%;
  @media (min-width: 1440px) {
    margin-top: 0;
  }
}

h2 {
  font-size: 1.5rem;
  font-weight: 400;
  margin-top: 3rem;
}

.carousel img {
  cursor: pointer;

  @media (min-width: 1024px) {
    width: 90%;
  }
}

.carousel {
  @media (max-width: 1024px) {
    img {
      width: 90%;
    }
    :deep(.carousel__next),
    :deep(.carousel__prev) {
      display: none !important;
    }
  }

  --vc-nav-color: #666262;
  --vc-nav-width: 40px;
  --vc-nav-height: 40px;
}
.fullscreen-carousel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999999;
  flex-direction: column;
}

.fullscreen-carousel img {
  width: 90%;
  height: auto;
  max-height: 80vh;
  border-radius: 10px;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: transparent;
  color: white;
  font-size: 30px;
  border: none;
  cursor: pointer;
  z-index: 999;
}

.project-navigation {
  display: flex;
  justify-content: space-between;
  width: 100%;
  // margin-top: 2rem;
}
</style>
